import React from 'react';
import TabNav from '../../../composants/TabNav/TabNav';
import { TabDescriptor } from '../types';
import { UnreadCounts } from '../hooks/useUnreadCounts';

interface OperationTabsProps {
  descriptors: TabDescriptor[];
  activeIndex: number;
  onSelect: (index: number) => void;
  unreadCounts?: UnreadCounts | null;
}

// Tooltips (cles par libelle, comme TabNav l'attend).
const DISABLED_TOOLTIPS: Record<string, string> = {
  'Questions et réponses': 'Disponible dès la consultation lancée',
  Analyse: 'Disponible dès la consultation lancée',
  'Notifications et signatures': "Disponible dès l'analyse clôturée",
  Messagerie: 'Disponible dès le marché signé',
  Évaluation: 'Disponible dès le marché signé',
};
const INACTIVE_TOOLTIPS: Record<string, string> = {
  Évaluation: 'Disponible dès le marché signé',
};

// Barre d'onglets : pilotee par descripteurs types, deleguee au generique TabNav
// (qui prend des index). On convertit descripteurs -> libelles + index disabled/inactive.
const OperationTabs: React.FC<OperationTabsProps> = ({
  descriptors,
  activeIndex,
  onSelect,
  unreadCounts,
}) => {
  const tabs = descriptors.map((d) => d.label);
  const disabledTabs = descriptors.map((d, i) => (d.disabled ? i : -1)).filter((i) => i >= 0);
  const inactiveTabs = descriptors.map((d, i) => (d.inactive ? i : -1)).filter((i) => i >= 0);

  // Badges de messages non-lus : map canal -> index d'onglet (par kind), count > 0 seulement.
  const notifications: { tabIndex: number; count: number }[] = [];
  if (unreadCounts) {
    const qrIndex = descriptors.findIndex((d) => d.kind === 'questions_reponses');
    const msgIndex = descriptors.findIndex((d) => d.kind === 'messagerie');
    if (qrIndex !== -1 && unreadCounts.questions_reponses > 0) {
      notifications.push({ tabIndex: qrIndex, count: unreadCounts.questions_reponses });
    }
    if (msgIndex !== -1 && unreadCounts.messagerie > 0) {
      notifications.push({ tabIndex: msgIndex, count: unreadCounts.messagerie });
    }
  }

  return (
    <TabNav
      tabs={tabs}
      activeTab={activeIndex}
      onTabChange={onSelect}
      disabledTabs={disabledTabs}
      inactiveTabs={inactiveTabs}
      disabledTabsTooltips={DISABLED_TOOLTIPS}
      inactiveTabsTooltips={INACTIVE_TOOLTIPS}
      notifications={notifications}
    />
  );
};

export default OperationTabs;
